/** Landing + public auth copy (merged into STRINGS). */
export const PUBLIC_STRINGS_EN = {
  'public.nav.home': 'Home',
  'public.nav.features': 'Features',
  'public.nav.industries': 'Business types',
  'public.nav.faq': 'FAQ',
  'public.nav.support': 'Support',
  'public.nav.signIn': 'Sign In',
  'public.nav.register': 'Register',
  'public.nav.menu': 'Menu',

  'public.hero.title': 'Run Your Business',
  'public.hero.accent': 'In One Place',
  'public.hero.lead':
    'Manage stock, sales, expenses, orders, quotations, invoices, printing, wakala cashbook, and reports from one platform. See income, costs, and profit clearly every day.',
  'public.hero.statBusinesses': 'Businesses',
  'public.hero.statTypes': 'Business Types',
  'public.hero.statSupport': 'Support',

  'public.features.eyebrow': 'Features',
  'public.features.title': 'Everything You Need',
  'public.features.intro':
    'From stock and POS to invoices, debts, expenses, and wakala — one workspace for day-to-day operations in Tanzania.',

  'public.industries.eyebrow': 'Business types',
  'public.industries.title': 'Built for all business types',
  'public.industries.lead':
    'Retail, pharmacy, restaurant, hardware, factory, and more — pick your profile when you register and get the right modules.',
  'public.industries.footnote': 'Need another vertical? Contact support — we add templates as customers grow.',

  'public.faq.eyebrow': 'FAQ',
  'public.faq.title': 'Frequently Asked Questions',
  'public.faq.lead': 'Quick answers about trials, payments, branches, and support.',

  'public.faq.trial.q': 'How long is the free trial?',
  'public.faq.trial.a':
    'Every new account gets a full-feature trial. When it ends, choose a plan to keep access.',
  'public.faq.safe.q': 'Is my business data safe?',
  'public.faq.safe.a':
    'Your data is stored securely with backups. Only your team with accounts can access your records.',
  'public.faq.pay.q': 'Which payment methods do you accept?',
  'public.faq.pay.a':
    'Mobile money and bank transfer for subscriptions. We activate your plan after payment confirmation.',
  'public.faq.branches.q': 'Can I manage multiple branches?',
  'public.faq.branches.a':
    'Yes. Higher plans support multiple branches, users, and consolidated reporting.',
  'public.faq.upgrade.q': 'Can I upgrade or change plans later?',
  'public.faq.upgrade.a':
    'You can move to a higher plan from your subscription page at any time.',
  'public.faq.expire.q': 'What happens when my subscription expires?',
  'public.faq.expire.a':
    'You can still sign in, but daily operations pause until you renew. Your data stays saved.',
  'public.faq.swahili.q': 'Do you offer support in Swahili?',
  'public.faq.swahili.a':
    'Yes. Support in Swahili and English via phone, WhatsApp, and email.',

  'public.cta.title': 'Ready to Get Started?',
  'public.cta.sub':
    'Join hundreds of businesses using cbonline app daily. Create your free account and manage operations with confidence.',
  'public.footer.rights': '© 2026 Classic Business Online. All rights reserved.',

  'public.legal.backRegister': 'Back to registration',
  'public.legal.backLogin': 'Back to sign in',
  'public.legal.backHome': 'Back to home',

  'auth.signInTitle': 'Sign in to your account',
  'auth.createAccountTitle': 'Create your account',
  'auth.email': 'Email or phone',
  'auth.emailHint': 'Owners sign in with email. Staff can use phone (07…) or email.',
  'auth.password': 'Password',
  'auth.forgotPassword': 'Forgot Password?',
  'auth.signIn': 'Sign In',
  'auth.signingIn': 'Signing in…',
  'auth.register': 'Register',
  'auth.createAccount': 'Create account',
  'auth.haveAccount': 'Already have an account?',
  'auth.noAccount': "Don't have an account?",
  'auth.signUp': 'Sign up',
  'auth.fullName': 'Full Name',
  'auth.businessName': 'Business Name',
  'auth.sendCode': 'Send verification code',
  'auth.showPassword': 'Show password',
  'auth.hidePassword': 'Hide password',

  'public.feat.inventory.title': 'Inventory Control',
  'public.feat.inventory.desc': 'Live stock, alerts, and movement history.',
  'public.feat.pos.title': 'Point of Sale (POS)',
  'public.feat.pos.desc': 'Fast checkout linked to branch and staff.',
  'public.feat.analytics.title': 'Performance Analytics',
  'public.feat.analytics.desc': 'Sales trends, margins, and top products.',
  'public.feat.reporting.title': 'Reporting',
  'public.feat.reporting.desc': 'Daily, weekly, and monthly views across modules.',
  'public.feat.quotation.title': 'Quotations',
  'public.feat.quotation.desc': 'Professional quotes and approved billing.',
  'public.feat.proforma.title': 'Proforma',
  'public.feat.proforma.desc': 'Proforma documents before final invoice.',
  'public.feat.invoice.title': 'Invoicing',
  'public.feat.invoice.desc': 'Invoices, balances due, and payment tracking.',
  'public.feat.receipt.title': 'Receipts',
  'public.feat.receipt.desc': 'Customer receipts tied to each sale.',
  'public.feat.efd.title': 'EFD-ready billing',
  'public.feat.efd.desc': 'Layouts aligned with TRA / EFD expectations.',
  'public.feat.expenses.title': 'Expense Tracking',
  'public.feat.expenses.desc': 'Boss, staff, and office spend by category.',
  'public.feat.debt.title': 'Debt Tracking',
  'public.feat.debt.desc': 'Credit sales and who owes what.',
  'public.feat.business-pl.title': 'Business Management & P&L',
  'public.feat.business-pl.desc': 'Revenue, expenses, and profit by period.',
  'public.feat.wakala.title': 'Wakala Cashbook',
  'public.feat.wakala.desc': 'Agent ledgers and daily balances.',
};

export const PUBLIC_STRINGS_SW = {
  'public.nav.home': 'Mwanzo',
  'public.nav.features': 'Vipengele',
  'public.nav.industries': 'Aina za biashara',
  'public.nav.faq': 'Maswali',
  'public.nav.support': 'Msaada',
  'public.nav.signIn': 'Ingia',
  'public.nav.register': 'Jisajili',
  'public.nav.menu': 'Menyu',

  'public.hero.title': 'Simamia Biashara Yako',
  'public.hero.accent': 'Mahali Pamoja',
  'public.hero.lead':
    'Dhibiti stock, mauzo, matumizi, maagizo, nukuu, ankara, uchapishaji, daftari la wakala, na ripoti kwenye mfumo mmoja. Ona mapato, gharama, na faida kila siku.',
  'public.hero.statBusinesses': 'Biashara',
  'public.hero.statTypes': 'Aina za biashara',
  'public.hero.statSupport': 'Msaada',

  'public.features.eyebrow': 'Vipengele',
  'public.features.title': 'Kila Kitu Unachohitaji',
  'public.features.intro':
    'Kutoka stock na POS hadi ankara, madeni, matumizi, na wakala — jukwaa moja kwa kazi za kila siku Tanzania.',

  'public.industries.eyebrow': 'Aina za biashara',
  'public.industries.title': 'Imejengwa kwa biashara zote',
  'public.industries.lead':
    'Rejareja, duka la dawa, mgahawa, hardware, kiwanda, na zaidi — chagua aina yako unaposajili na upate moduli sahihi.',
  'public.industries.footnote': 'Unahitaji sekta nyingine? Wasiliana na msaada — tunaongeza templeti kadri wateja wanavyokua.',

  'public.faq.eyebrow': 'Maswali',
  'public.faq.title': 'Maswali Yanayoulizwa Mara kwa Mara',
  'public.faq.lead': 'Majibu ya haraka kuhusu jaribio, malipo, matawi, na msaada.',

  'public.faq.trial.q': 'Jaribio la bure lina muda gani?',
  'public.faq.trial.a':
    'Akaunti mpya inapata jaribio la vipengele vyote. Likiisha, chagua mpango ili uendelee.',
  'public.faq.safe.q': 'Data ya biashara yangu iko salama?',
  'public.faq.safe.a':
    'Data inahifadhiwa kwa usalama na nakala rudufu. Timu yako tu ndiyo inaoweza kuiona.',
  'public.faq.pay.q': 'Mnakubali njia gani za malipo?',
  'public.faq.pay.a':
    'M-Pesa na uhamisho wa benki kwa usajili. Mpango unaanzishwa baada ya uthibitisho wa malipo.',
  'public.faq.branches.q': 'Naweza kusimamia matawi mengi?',
  'public.faq.branches.a':
    'Ndiyo. Mipango ya juu inaruhusu matawi mengi, watumiaji, na ripoti zilizounganishwa.',
  'public.faq.upgrade.q': 'Naweza kubadilisha mpango baadaye?',
  'public.faq.upgrade.a':
    'Unaweza kupanda mpango kutoka ukurasa wa usajili wakati wowote.',
  'public.faq.expire.q': 'Nini hutokea usajili ukiisha?',
  'public.faq.expire.a':
    'Bado unaweza kuingia, lakini shughuli zinasimama hadi urenew. Data yako hubaki.',
  'public.faq.swahili.q': 'Mna msaada kwa Kiswahili?',
  'public.faq.swahili.a':
    'Ndiyo. Msaada kwa Kiswahili na Kiingereza kupitia simu, WhatsApp, na barua pepe.',

  'public.cta.title': 'Uko Tayari Kuanza?',
  'public.cta.sub':
    'Jiunge na mamia ya biashara zinazotumia cbonline app kila siku. Fungua akaunti yako bure na simamia shughuli kwa ujasiri.',
  'public.footer.rights': '© 2026 Classic Business Online. Haki zote zimehifadhiwa.',

  'public.legal.backRegister': 'Rudi kwenye usajili',
  'public.legal.backLogin': 'Rudi kwenye kuingia',
  'public.legal.backHome': 'Rudi mwanzo',

  'auth.signInTitle': 'Ingia kwenye akaunti yako',
  'auth.createAccountTitle': 'Fungua akaunti yako',
  'auth.email': 'Barua pepe au simu',
  'auth.emailHint': 'Mmiliki: barua pepe. Wafanyakazi: namba ya simu (07…) au barua pepe.',
  'auth.password': 'Nenosiri',
  'auth.forgotPassword': 'Umesahau nenosiri?',
  'auth.signIn': 'Ingia',
  'auth.signingIn': 'Inaingia…',
  'auth.register': 'Jisajili',
  'auth.createAccount': 'Fungua akaunti',
  'auth.haveAccount': 'Tayari una akaunti?',
  'auth.noAccount': 'Huna akaunti?',
  'auth.signUp': 'Jisajili sasa',
  'auth.fullName': 'Jina kamili',
  'auth.businessName': 'Jina la biashara',
  'auth.sendCode': 'Tuma msimbo wa uthibitisho',
  'auth.showPassword': 'Onyesha nenosiri',
  'auth.hidePassword': 'Ficha nenosiri',

  'public.feat.inventory.title': 'Udhibiti wa Stock',
  'public.feat.inventory.desc': 'Stock hai, tahadhari, na historia ya mabadiliko.',
  'public.feat.pos.title': 'Mauzo (POS)',
  'public.feat.pos.desc': 'Mauzo ya haraka yameunganishwa na tawi na staff.',
  'public.feat.analytics.title': 'Takwimu za Utendaji',
  'public.feat.analytics.desc': 'Mienendo ya mauzo, faida, na bidhaa bora.',
  'public.feat.reporting.title': 'Ripoti',
  'public.feat.reporting.desc': 'Muhtasari wa kila siku, wiki, na mwezi.',
  'public.feat.quotation.title': 'Nukuu',
  'public.feat.quotation.desc': 'Nukuu za kitaalamu na malipo yaliyoidhinishwa.',
  'public.feat.proforma.title': 'Proforma',
  'public.feat.proforma.desc': 'Hati za proforma kabla ya ankara ya mwisho.',
  'public.feat.invoice.title': 'Ankara',
  'public.feat.invoice.desc': 'Ankara, salio, na ufuatiliaji wa malipo.',
  'public.feat.receipt.title': 'Risiti',
  'public.feat.receipt.desc': 'Risiti za wateja zimeunganishwa na mauzo.',
  'public.feat.efd.title': 'Ankara za EFD',
  'public.feat.efd.desc': 'Muundo unaolingana na mahitaji ya TRA/EFD.',
  'public.feat.expenses.title': 'Ufuatiliaji wa Matumizi',
  'public.feat.expenses.desc': 'Matumizi ya mmiliki, staff, na ofisi.',
  'public.feat.debt.title': 'Ufuatiliaji wa Madeni',
  'public.feat.debt.desc': 'Mauzo ya mkopo na deni lililobaki.',
  'public.feat.business-pl.title': 'Usimamizi & Faida/Hasara',
  'public.feat.business-pl.desc': 'Mapato, gharama, na faida kwa kipindi.',
  'public.feat.wakala.title': 'Daftari la Wakala',
  'public.feat.wakala.desc': 'Daftari la wakala na salio la kila siku.',
};
